import {
  ColumnType,
  RIGHT_ALIGN_CLASS,
  textView,
  titleViewClickable,
} from "./functions";

export const inactiveTenantsColumns = (isSmallScreen = false): ColumnType[] => [
  {
    label: "entities:customer",
    name: "customerName",
    getView: titleViewClickable,
  },
  {
    label: "statisticsLabels:previousRegistrations",
    name: "previousRegistrations",
    getView: (value) => textView(value, isSmallScreen ? RIGHT_ALIGN_CLASS : ""),
  },
];
